'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { ProductTabContainer } from './product-tab-container';
import { HtmlDescription } from '../../../ui/html-description';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductTabDescription({
  product,
  title,
}: {
  product: ProductDetailData;
  title: string;
}) {
  return (
    <ProductTabContainer title={title}>
      <HtmlDescription
        sectionContent
        color="foreground"
        content={product.description}
        size="sm"
        className={cn('w-full', 'ea-product-tab-description__content')}
      />
    </ProductTabContainer>
  );
}
